module.exports = __webpack_public_path__ + "img/NITDA_Audit_Compliant_Logo_june_2022.0f7e8350.svg";